import React from "react";

/**
 * Site-wide announcement strip. Sits ABOVE the sticky header at the very top
 * of the document. Not dismissible — this is core launch comms for the
 * pre-order window.
 */
export default function AnnouncementBar() {
  return (
    <div
      role="status"
      data-testid="announcement-bar"
      className="sticky top-0 z-50 bg-navy text-white"
    >
      <div className="container-pc flex items-center justify-center h-8 text-[12px] sm:text-[13px] font-medium tracking-wide">
        <span className="hidden sm:inline">Pre-orders now open</span>
        <span className="sm:hidden">Pre-orders open</span>
        <Dot />
        <span>Ships July 2026</span>
        <Dot />
        <span className="hidden sm:inline">UK tracked delivery</span>
        <span className="sm:hidden">UK tracked</span>
      </div>
    </div>
  );
}

function Dot() {
  return (
    <span
      aria-hidden="true"
      className="mx-2.5 sm:mx-3 inline-block w-1 h-1 rounded-full bg-cyan"
    />
  );
}
